const s = require("./navigation.module.scss");

import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { faHome, faEye, faCloud, faCog, faUser } from "@fortawesome/free-solid-svg-icons"; //fontawesome.com
import MultiSelect from "components/multiselect";
import MenuItem from "components/menuItem";
import httpService from "core/infrastructure/http";
import TimePicker from "components/timePicker";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import gb from "date-fns/locale/en-GB";
import { ApplicationState } from "core/app";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { GetAvailableDatesResponse } from "core/backend/data";
import { NavLink, useLocation } from "react-router-dom";
import JaoLogoMenu from "components/jaoLogoMenu";

registerLocale("en-GB", gb);

interface StateProps {
    applicationState: ApplicationState;
}

interface Horizon {
    id: string;
    text: string;
}

export const horizons: Horizon[] = [
    { id: "ID1", text: "IDA 1" },
    { id: "ID2", text: "IDA 2" },
    { id: "ID3", text: "IDA 3" },

    { id: "CCR", text: "Italy North CCR" }
];

type NavigationProps = StateProps & WithTranslation;
const Navigation = ({ t, applicationState }: NavigationProps) => {
    const pageList = applicationState.pages.map(p => p.config);
    const initialDates: string[] = []
    const [availableDates, setAvailableDates] = useState(initialDates);
    const { pathname } = useLocation();

    const filteredHorizons = horizons.filter(h => h.id == applicationState.horizon);
    const selectedHorizon = horizons.length == 0 ? null : filteredHorizons.length == 1 ? filteredHorizons[0] : horizons[0];

    const mapHorizon = (item: Horizon) => {
        const isSelected = selectedHorizon == item;
        let toPath = pathname;
        horizons.forEach(h => toPath = toPath.replace(h.id, item.id));

        if (!pageList.some(p => "/" + p.webUrl === toPath)) { // if the given page is not present in the horizon, open the first page
            toPath = "/" + pageList.find(p => p.webUrl.includes(item.id)).webUrl;
        }

        return <NavLink key={item.id}
            onClick={() => applicationState.handleHorizonChange(item.id)}
            to={ toPath }
            style={{
                border: "1px solid #cbd1d8", borderRadius: "3px", height: "30px"
                , backgroundColor: isSelected ? "#a60045" : "white"
                , color: isSelected ? "white" : "black"
                , textAlign: "center"
                , lineHeight: "30px"
                , cursor: "pointer"
                , textDecoration: "none"
                , whiteSpace: "nowrap"
                , padding: "0px 5px 0px 5px"
            }} >
            {item.text}
        </NavLink>
    }

    useEffect(() => {
        let path = pathname.replace("/", "").replace("/", "").replace("/", "");
        if (path === "") return;

        (async function runAsync() {
            const response = await httpService.apiPost<GetAvailableDatesResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/data/availableDates",
                query: {
                    Utc: applicationState.getRootUtcTime().toISOString(),
                    Page: path
                },
                senderId: "navigation"
            })();

            if (response.ok && response.data != null) {
                setAvailableDates(response.data.availableDates);
            }
        })();
    }, [pathname]);
    return (
        <div className="sidebar"
            style={{ display: "grid", gridTemplateRows: "auto auto auto auto auto auto auto auto minmax(0,1fr)", height: "100vh", backgroundColor: "white", padding: "0.5rem 1rem", zIndex: 5 }}>
            <a aria-current="page" className={s.logo} href="/"><JaoLogoMenu />{t("common:appNameTitle")}</a>
            <NavLink to="/ibwt" className={s.subTitle}>{t("ibwt_common:title")}</NavLink>
            <div style={{ marginLeft: "20px" }}>
                <div className="inputlabel">{t("common:date")}</div>
                {applicationState.dateSteps != "" && <div style={{ position: "absolute", left: "35px" }} className={classNames(s.arrow, s.arrowLeft)}
                    onClick={() => {
                        let newDate = new Date(applicationState.selectedDate);
                        if (applicationState.dateSteps == "Y") newDate.setFullYear(newDate.getFullYear() - 1);
                        if (applicationState.dateSteps != "Y") newDate.setDate(newDate.getDate() - 1);
                        applicationState.handleDateChange(newDate);
                    }}></div>}
                {applicationState.dateSteps != "" && <div style={{ position: "absolute", left: "210px" }} className={classNames(s.arrow, s.arrowRight)}
                    onClick={() => {
                        let newDate = new Date(applicationState.selectedDate);
                        if (applicationState.dateSteps == "Y") newDate.setFullYear(newDate.getFullYear() + 1);
                        if (applicationState.dateSteps != "Y") newDate.setDate(newDate.getDate() + 1);
                        applicationState.handleDateChange(newDate);
                    }}></div>}
                <ReactDatePicker className={classNames("inputBorder", applicationState.dateSteps != "" ? "" : "disabled")} locale="en-GB" placeholderText="Weeks start on Monday" isClearable={false} fixedHeight todayButton="Today"
                    dateFormat={applicationState.dateSteps == "Y" ? "yyyy" : "yyyy-MM-dd"}
                    showYearPicker={applicationState.dateSteps == "Y"}
                    selected={applicationState.selectedDate}
                    onChange={applicationState.handleDateChange}
                    highlightDates={availableDates.map(d => new Date(d))}
                />
            </div>
            <div style={{ marginLeft: "20px" }}>
                <div className="inputlabel">{t("common:hour")}  (CET)</div>
                {applicationState.dateSteps.startsWith("H") && <div style={{ position: "absolute", left: "35px" }} className={classNames(s.arrow, s.arrowLeft)}
                    onClick={() => {
                        let newDate = new Date(applicationState.selectedDate.setUTCHours(applicationState.selectedDate.getUTCHours() - 1));
                        if (applicationState.dateSteps == "H12+" && newDate.getHours() < 12) newDate.setHours(-1);
                        if (applicationState.dateSteps == "H16+" && newDate.getHours() < 16) newDate.setHours(-1);
                        applicationState.handleDateChange(newDate);
                    }}></div>}
                {applicationState.dateSteps.startsWith("H") && <div style={{ position: "absolute", left: "210px" }} className={classNames(s.arrow, s.arrowRight)}
                    onClick={() => {
                        let newDate = new Date(applicationState.selectedDate.setUTCHours(applicationState.selectedDate.getUTCHours() + 1));
                        if (applicationState.dateSteps == "H12+" && newDate.getHours() < 12) newDate.setHours(12);
                        if (applicationState.dateSteps == "H16+" && newDate.getHours() < 16) newDate.setHours(16);
                        applicationState.handleDateChange(newDate);
                    }}></div>}
                <TimePicker applicationState={applicationState} dateSteps={applicationState.dateSteps} selectedDate={applicationState.selectedDate} onChange={applicationState.handleDateChange} />
            </div>
            <div style={{ marginLeft: "20px" }}>
                <div className="inputlabel">{t("common:hub")}</div>
                <MultiSelect enabled={applicationState.isHubEnabled} data={applicationState.selectedHubs} onChange={applicationState.handleHubChange} />
            </div>
            <div style={{ marginLeft: "20px" }}>
                <div className="inputlabel">{t("common:border")}</div>
                <MultiSelect enabled={applicationState.isBorderEnabled} data={applicationState.selectedBorders} onChange={applicationState.handleBorderChange} />
            </div>
            <div style={{ marginLeft: "20px", display: horizons.length <= 1 ? "none" : "block" }}>
                <div className="inputlabel">IBWT IDA</div>
                <div style={{ display: "grid", gridTemplateColumns: "auto ".repeat(horizons.filter(item => !item.id.startsWith("CCR")).length), gap: "5px", width: "150px" }}>
                    {horizons.filter(item => !item.id.startsWith("CCR")).map(mapHorizon)}
                </div>
                <div style={{ display: "grid", justifyContent: "space-around", paddingTop: "5px", gridTemplateColumns: "auto ".repeat(horizons.filter(item => item.id.startsWith("CCR")).length), gap: "5px", width: "150px" }}>
                    {horizons.filter(item => item.id.startsWith("CCR")).map(mapHorizon)}
                </div>
            </div>
            <div style={{ display: "flex", marginLeft: "-20px", marginTop: "1rem" }}>
                <MenuItem route="/home" icon={faHome} title={t("ibwt_common:menuHome")} style={{ fontSize: "120%", fontWeight: "bold" }} />
                <MenuItem route="/monitoring" icon={faEye} title="" style={{ fontSize: "120%", fontWeight: "bold" }} />
                <MenuItem route="/api" icon={faCloud} title="" style={{ fontSize: "120%", fontWeight: "bold" }} />
                {applicationState.userRole === "JaoUser" || applicationState.userRole === "JaoAdmin" || applicationState.userRole === "Licquid" ?
                    <MenuItem route="/jaoLogin" icon={faUser} title="" style={{ fontSize: "120%", fontWeight: "bold" }} /> : ""}
            </div>
            <div style={{ margin: "0", overflowY: "auto", overflow: "auto", marginRight: "-1rem", marginLeft: "-1rem", paddingLeft: "1rem" }}>
                <div className="animation_vertical_shown">
                    {
                        pageList.filter((p, i, a) => p.menu != "" && p.webUrl.startsWith(selectedHorizon?.id) && a.indexOf(p) === i)
                            .map(p => <MenuItem key={p.webUrl} route={"/" + p.webUrl} title={t(p.menu)} />)
                    }
                </div>
            </div>
        </div>);
};

const translated = withTranslation("ibwt_common")(Navigation);

export default translated;